import { useMutation } from '@tanstack/react-query';
import fetchLiveChat from 'app/services/liveChat';
import queryClient from 'app/services/queryClient';

import { LiveChatApiResponse } from '../fetch/useFetchLiveChat';

type MutationParams = { scenarioChange?: boolean; uuid?: string };

export default function useMutateLiveChat() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useMutation<LiveChatApiResponse, any, MutationParams>({
    mutationFn: fetchLiveChat,
    onSuccess(data) {
      queryClient.setQueryData(['liveChat', data.uuid], data);
    },
  });
}
